// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   LoginPortal — standalone CSS (no App.css dependency).
   All var(--*) from App.css resolved to their light-mode values.
   Dark mode override block included at the bottom.
   Lato + Bootstrap Icons bundled in main.jsx (sin CDN — APK/Tiger suele bloquear jsdelivr).
   ───────────────────────────────────────────── */

/* ── Design tokens (self-contained) ─────────── */
:root {
    color-scheme: light;
    --lp-font-family: 'Lato', sans-serif;
    --lp-fw-bold: 700;
    --lp-fw-black: 900;

    --lp-h-titulos: #4D4D4D;
    --lp-h-subtitulos: #757575;
    --lp-blue-dark: #28466D;
    --lp-text-primary: #4d4d4d;
    --lp-text-on-primary: #ffffff;
    --lp-text-jph-brand: var(--lp-blue-dark);
    --lp-border-light: #CBD5E1;
    --lp-surface-card: #ffffff;
    --lp-background-btns: var(--lp-brand-primary-soft, #E0EEFF);
    --lp-background-divs: var(--lp-brand-surface-soft, #F3F8FF);
    --lp-btn-hover: #d0e4ff;
    --lp-modal-close-hover: #e5e7eb;
    --lp-error-bg: #fef2f2;
    --lp-error-border: #fee2e2;
    --lp-error-color: #ef4444;
    --lp-info-bg: #eff6ff;
    --lp-info-border: #bfdbfe;
    --lp-info-color: #1e40af;
    --lp-spinner-ring: rgba(40, 70, 109, 0.2);
    --lp-backdrop: rgba(0, 0, 0, 0.45);
    --lp-modal-shadow: 0 12px 48px rgba(0, 0, 0, 0.28);
}

:root[data-theme="dark"] {
    color-scheme: dark;
    --lp-h-titulos: #e6ebf4;
    --lp-h-subtitulos: #aab4c4;
    --lp-blue-dark: #28466D;
    --lp-text-primary: #e6ebf4;
    --lp-text-on-primary: #ffffff;
    --lp-text-jph-brand: #ffffff;
    --lp-border-light: #314155;
    --lp-surface-card: #18212f;
    --lp-background-btns: #223246;
    --lp-background-divs: #1d2736;
    --lp-btn-hover: #2b3d53;
    --lp-modal-close-hover: #2f3a4a;
    --lp-error-bg: #47242b;
    --lp-error-border: #c0676f;
    --lp-error-color: #f1989d;
    --lp-info-bg: #1e3a5f;
    --lp-info-border: #3b82f6;
    --lp-info-color: #93c5fd;
    --lp-spinner-ring: rgba(40, 70, 109, 0.4);
    --lp-backdrop: rgba(2, 6, 23, 0.72);
    --lp-modal-shadow: 0 14px 34px -18px rgba(0, 0, 0, 0.7);
}

/* ── Page Container ─────────────────────────── */
.auth-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: var(--lp-surface-card);
    font-family: var(--lp-font-family);
}

/* ── Transición login → tenant ─────────────────
   Replica el Splash del WMS para evitar cambios visuales entre documentos. */
.login-transition-loader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--lp-surface-card);
    font-family: var(--lp-font-family);
}

.login-transition-logo {
    width: min(250px, 58vw);
    height: auto;
    object-fit: contain;
}

.login-transition-bar {
    width: min(250px, 58vw);
    height: 6px;
    margin-top: 1.5rem;
    overflow: hidden;
    background: var(--lp-background-divs);
    border-radius: 10px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.login-transition-progress {
    width: 0;
    height: 100%;
    border-radius: inherit;
    background: var(--lp-brand-accent, #cd9a62);
    transition: width 0.4s ease-out;
}

@media (prefers-reduced-motion: reduce) {
    .login-transition-progress {
        transition: none;
    }
}

/* ── Header Mimic ───────────────────────────── */
.app-header {
    background-color: var(--lp-surface-card);
    padding: 1rem 0;
}

.header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
}

.header-logo {
    width: 67px;
    height: 48px;
    object-fit: contain;
}

.auth-theme-toggle {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--lp-border-light);
    border-radius: 8px;
    background: var(--lp-background-divs);
    color: var(--lp-h-titulos);
    cursor: pointer;
    font-size: 1.15rem;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.auth-theme-toggle:hover {
    background: var(--lp-btn-hover);
    color: var(--lp-text-primary);
}

.auth-theme-toggle:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px color-mix(in srgb, var(--lp-blue-dark) 35%, transparent);
}

/* ── Main Content Area ──────────────────────── */
.auth-content {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 24px;
}

/* ── Card (Seamless) ────────────────────────── */
.auth-card {
    width: 100%;
    max-width: 440px;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.auth-card-header {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.auth-channel-badge {
    display: inline-block;
    align-self: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.6875rem;
    font-weight: var(--lp-fw-bold);
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--lp-text-jph-brand);
    background: var(--lp-background-btns);
    border: 1px solid var(--lp-border-light);
    transition: background-color 0.2s ease, color 0.2s ease;
}

.auth-title {
    font-size: 1.25rem;
    font-weight: var(--lp-fw-black);
    color: var(--lp-h-titulos);
    margin: 0;
}

.auth-subtitle {
    font-size: 0.75rem;
    color: var(--lp-h-subtitulos);
    margin: 0;
}

/* ── Form ───────────────────────────────────── */
.auth-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.auth-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.auth-label {
    font-size: 0.75rem;
    font-weight: var(--lp-fw-bold);
    color: var(--lp-h-titulos);
}

.auth-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.auth-input-icon {
    position: absolute;
    left: 16px;
    color: var(--lp-h-subtitulos);
    font-size: 1.2rem;
}

.auth-input {
    width: 100%;
    height: 52px;
    background: var(--lp-surface-card);
    border: 1px solid var(--lp-border-light);
    border-radius: 8px;
    padding: 0 16px 0 48px;
    font-size: 0.75rem;
    color: var(--lp-h-titulos);
    font-family: inherit;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.auth-input:focus {
    outline: none;
    box-shadow: 0 0 0 1px var(--lp-blue-dark);
}

.auth-input.has-icon-right {
    padding-right: 48px;
}

.auth-forgot-link {
    align-self: flex-end;
    margin-top: -4px;
    background: none;
    border: none;
    padding: 0;
    font-size: 0.75rem;
    font-weight: var(--lp-fw-bold);
    color: var(--lp-text-jph-brand);
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s ease;
}

.auth-forgot-link:hover {
    text-decoration: underline;
}

.auth-input-btn {
    position: absolute;
    right: 12px;
    background: none;
    border: none;
    color: var(--lp-border-light);
    cursor: pointer;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    padding: 8px;
}

.auth-btn-submit {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background-color: var(--lp-blue-dark);
    color: var(--lp-text-on-primary);
    border: 1px solid color-mix(in srgb, var(--lp-blue-dark) 72%, var(--lp-border-light));
    border-radius: 8px;
    font-size: 1rem;
    font-weight: var(--lp-fw-bold);
    font-family: inherit;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
    margin-top: 8px;
}

.auth-btn-submit:hover:not(:disabled) {
    background-color: color-mix(in srgb, var(--lp-blue-dark) 88%, var(--lp-surface-card));
    border-color: color-mix(in srgb, var(--lp-blue-dark) 60%, var(--lp-border-light));
    color: var(--lp-text-on-primary);
}

.auth-btn-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.auth-submit-row {
    display: flex;
    align-items: stretch;
    gap: 10px;
    margin-top: 8px;
}

.auth-submit-row .auth-btn-submit {
    flex: 1;
    margin-top: 0;
}

.auth-social-btn {
    flex: 0 0 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--lp-background-divs);
    border: 1px solid var(--lp-border-light);
    border-radius: 8px;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
    cursor: pointer;
    color: var(--lp-text-primary);
    font-size: 1.35rem;
}

.auth-social-btn:hover:not(:disabled) {
    background-color: var(--lp-btn-hover);
    border-color: color-mix(in srgb, var(--lp-text-jph-brand) 35%, var(--lp-border-light));
    color: var(--lp-text-primary);
}

.auth-social-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.auth-spinner--social {
    width: 20px;
    height: 20px;
}

.auth-btn-submit--biometric {
    gap: 10px;
}

.auth-method-switch {
    align-self: center;
    margin-top: 4px;
    background: none;
    border: none;
    padding: 8px 4px;
    font-size: 0.8125rem;
    font-weight: var(--lp-fw-bold);
    color: var(--lp-text-jph-brand);
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s ease;
}

.auth-method-switch:hover:not(:disabled) {
    text-decoration: underline;
}

.auth-method-switch:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Footer / Support ───────────────────────── */
.auth-footer-support {
    text-align: center;
    font-size: 0.75rem;
    color: var(--lp-h-titulos);
}

.auth-footer-support a {
    color: var(--lp-h-titulos);
    font-weight: var(--lp-fw-bold);
    text-decoration: none;
}

.auth-footer-support a:hover {
    text-decoration: underline;
}

/* ── Alerts ─────────────────────────────────── */
.auth-error,
.auth-info {
    padding: 12px;
    border-radius: 8px;
    font-size: 0.9rem;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    line-height: 1.45;
}

.auth-error {
    background-color: var(--lp-error-bg);
    border: 1px solid var(--lp-error-border);
    color: var(--lp-error-color);
}

.auth-info {
    background-color: var(--lp-info-bg);
    border: 1px solid var(--lp-info-border);
    color: var(--lp-info-color);
}

/* ── Spinner ────────────────────────────────── */
.auth-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid var(--lp-spinner-ring);
    border-top-color: var(--lp-blue-dark);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.auth-btn-submit .auth-spinner {
    border-color: color-mix(in srgb, var(--lp-text-on-primary) 35%, transparent);
    border-top-color: var(--lp-text-on-primary);
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* ── Modal (Forgot Password) ────────────────── */
.auth-modal-backdrop {
    position: fixed;
    inset: 0;
    background: var(--lp-backdrop);
    z-index: 3200;
}

.auth-modal-panel {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--lp-surface-card);
    border-radius: 16px;
    padding: 24px 20px 20px;
    width: min(440px, calc(100vw - 32px));
    display: flex;
    flex-direction: column;
    gap: 16px;
    z-index: 3201;
    box-shadow: var(--lp-modal-shadow);
}

.auth-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.auth-modal-title-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.auth-modal-title {
    margin: 0;
    font-size: 1.05rem;
    font-weight: var(--lp-fw-bold);
    color: var(--lp-h-titulos);
}

.auth-modal-subtitle {
    margin: 0;
    font-size: 0.75rem;
    color: var(--lp-h-subtitulos);
}

.auth-modal-close {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border: none;
    background: var(--lp-background-divs);
    border-radius: 8px;
    color: var(--lp-h-subtitulos);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
}

.auth-modal-close:hover:not(:disabled) {
    background: var(--lp-modal-close-hover);
    color: var(--lp-h-titulos);
}

.auth-modal-close:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.auth-modal-panel .auth-form {
    gap: 16px;
}

.auth-modal-footer {
    display: flex;
    gap: 10px;
    padding-top: 4px;
}

.auth-modal-footer .auth-btn-secondary,
.auth-modal-footer .auth-btn-primary {
    flex: 1 1 0;
    min-height: 44px;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: var(--lp-fw-bold);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
    white-space: nowrap;
}

.auth-modal-footer .auth-btn-secondary {
    background: var(--lp-background-divs);
    border: 1px solid var(--lp-border-light);
    color: var(--lp-h-titulos);
}

.auth-modal-footer .auth-btn-secondary:hover:not(:disabled) {
    background: var(--lp-modal-close-hover);
}

.auth-modal-footer .auth-btn-primary {
    background-color: var(--lp-blue-dark);
    color: var(--lp-text-on-primary);
    border: 1px solid color-mix(in srgb, var(--lp-blue-dark) 72%, var(--lp-border-light));
}

.auth-modal-footer .auth-btn-primary:hover:not(:disabled) {
    background-color: color-mix(in srgb, var(--lp-blue-dark) 88%, var(--lp-surface-card));
    border-color: color-mix(in srgb, var(--lp-blue-dark) 60%, var(--lp-border-light));
    color: var(--lp-text-on-primary);
}

.auth-modal-footer .auth-btn-secondary:disabled,
.auth-modal-footer .auth-btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Responsive ─────────────────────────────── */
@media (max-width: 768px) {
    .header-top {
        padding: 1rem;
    }

    .auth-card {
        padding: 0;
        gap: 24px;
    }

    .auth-title {
        font-size: 1.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoginPortal.css"],"names":[],"mappings":"AAAA;;;;;kDAKkD;;AAElD,kDAAkD;AAClD;IACI,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;;IAElB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,wCAAwC;IACxC,0BAA0B;IAC1B,0BAA0B;IAC1B,2DAA2D;IAC3D,2DAA2D;IAC3D,uBAAuB;IACvB,+BAA+B;IAC/B,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,yCAAyC;IACzC,kCAAkC;IAClC,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,yCAAyC;IACzC,mCAAmC;IACnC,uDAAuD;AAC3D;;AAEA,kDAAkD;AAClD;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;6EAC6E;AAC7E;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,kDAAkD;AAClD;IACI,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8EAA8E;AAClF;;AAEA,kDAAkD;AAClD;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,qCAAqC;IACrC,wCAAwC;IACxC,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;AACb;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,+EAA+E;AACnF;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,qCAAqC;IACrC,gCAAgC;IAChC,qFAAqF;IACrF,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;IACf,+EAA+E;IAC/E,eAAe;AACnB;;AAEA;IACI,qFAAqF;IACrF,iFAAiF;IACjF,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;IAClB,+EAA+E;IAC/E,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,sFAAsF;IACtF,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kDAAkD;AAClD;;IAEI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,4EAA4E;IAC5E,2CAA2C;AAC/C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,kDAAkD;AAClD;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,qFAAqF;AACzF;;AAEA;IACI,qFAAqF;IACrF,iFAAiF;IACjF,gCAAgC;AACpC;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kDAAkD;AAClD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* ─────────────────────────────────────────────\n   LoginPortal — standalone CSS (no App.css dependency).\n   All var(--*) from App.css resolved to their light-mode values.\n   Dark mode override block included at the bottom.\n   Lato + Bootstrap Icons bundled in main.jsx (sin CDN — APK/Tiger suele bloquear jsdelivr).\n   ───────────────────────────────────────────── */\n\n/* ── Design tokens (self-contained) ─────────── */\n:root {\n    color-scheme: light;\n    --lp-font-family: 'Lato', sans-serif;\n    --lp-fw-bold: 700;\n    --lp-fw-black: 900;\n\n    --lp-h-titulos: #4D4D4D;\n    --lp-h-subtitulos: #757575;\n    --lp-blue-dark: #28466D;\n    --lp-text-primary: #4d4d4d;\n    --lp-text-on-primary: #ffffff;\n    --lp-text-jph-brand: var(--lp-blue-dark);\n    --lp-border-light: #CBD5E1;\n    --lp-surface-card: #ffffff;\n    --lp-background-btns: var(--lp-brand-primary-soft, #E0EEFF);\n    --lp-background-divs: var(--lp-brand-surface-soft, #F3F8FF);\n    --lp-btn-hover: #d0e4ff;\n    --lp-modal-close-hover: #e5e7eb;\n    --lp-error-bg: #fef2f2;\n    --lp-error-border: #fee2e2;\n    --lp-error-color: #ef4444;\n    --lp-info-bg: #eff6ff;\n    --lp-info-border: #bfdbfe;\n    --lp-info-color: #1e40af;\n    --lp-spinner-ring: rgba(40, 70, 109, 0.2);\n    --lp-backdrop: rgba(0, 0, 0, 0.45);\n    --lp-modal-shadow: 0 12px 48px rgba(0, 0, 0, 0.28);\n}\n\n:root[data-theme=\"dark\"] {\n    color-scheme: dark;\n    --lp-h-titulos: #e6ebf4;\n    --lp-h-subtitulos: #aab4c4;\n    --lp-blue-dark: #28466D;\n    --lp-text-primary: #e6ebf4;\n    --lp-text-on-primary: #ffffff;\n    --lp-text-jph-brand: #ffffff;\n    --lp-border-light: #314155;\n    --lp-surface-card: #18212f;\n    --lp-background-btns: #223246;\n    --lp-background-divs: #1d2736;\n    --lp-btn-hover: #2b3d53;\n    --lp-modal-close-hover: #2f3a4a;\n    --lp-error-bg: #47242b;\n    --lp-error-border: #c0676f;\n    --lp-error-color: #f1989d;\n    --lp-info-bg: #1e3a5f;\n    --lp-info-border: #3b82f6;\n    --lp-info-color: #93c5fd;\n    --lp-spinner-ring: rgba(40, 70, 109, 0.4);\n    --lp-backdrop: rgba(2, 6, 23, 0.72);\n    --lp-modal-shadow: 0 14px 34px -18px rgba(0, 0, 0, 0.7);\n}\n\n/* ── Page Container ─────────────────────────── */\n.auth-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--lp-surface-card);\n    font-family: var(--lp-font-family);\n}\n\n/* ── Transición login → tenant ─────────────────\n   Replica el Splash del WMS para evitar cambios visuales entre documentos. */\n.login-transition-loader {\n    position: fixed;\n    inset: 0;\n    z-index: 9999;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: var(--lp-surface-card);\n    font-family: var(--lp-font-family);\n}\n\n.login-transition-logo {\n    width: min(250px, 58vw);\n    height: auto;\n    object-fit: contain;\n}\n\n.login-transition-bar {\n    width: min(250px, 58vw);\n    height: 6px;\n    margin-top: 1.5rem;\n    overflow: hidden;\n    background: var(--lp-background-divs);\n    border-radius: 10px;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.login-transition-progress {\n    width: 0;\n    height: 100%;\n    border-radius: inherit;\n    background: var(--lp-brand-accent, #cd9a62);\n    transition: width 0.4s ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .login-transition-progress {\n        transition: none;\n    }\n}\n\n/* ── Header Mimic ───────────────────────────── */\n.app-header {\n    background-color: var(--lp-surface-card);\n    padding: 1rem 0;\n}\n\n.header-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 2rem;\n}\n\n.header-logo {\n    width: 67px;\n    height: 48px;\n    object-fit: contain;\n}\n\n.auth-theme-toggle {\n    width: 44px;\n    height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--lp-border-light);\n    border-radius: 8px;\n    background: var(--lp-background-divs);\n    color: var(--lp-h-titulos);\n    cursor: pointer;\n    font-size: 1.15rem;\n    transition: background 0.2s, border-color 0.2s, color 0.2s;\n}\n\n.auth-theme-toggle:hover {\n    background: var(--lp-btn-hover);\n    color: var(--lp-text-primary);\n}\n\n.auth-theme-toggle:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px color-mix(in srgb, var(--lp-blue-dark) 35%, transparent);\n}\n\n/* ── Main Content Area ──────────────────────── */\n.auth-content {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    padding: 24px;\n}\n\n/* ── Card (Seamless) ────────────────────────── */\n.auth-card {\n    width: 100%;\n    max-width: 440px;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.auth-card-header {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.auth-channel-badge {\n    display: inline-block;\n    align-self: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 0.6875rem;\n    font-weight: var(--lp-fw-bold);\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: var(--lp-text-jph-brand);\n    background: var(--lp-background-btns);\n    border: 1px solid var(--lp-border-light);\n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.auth-title {\n    font-size: 1.25rem;\n    font-weight: var(--lp-fw-black);\n    color: var(--lp-h-titulos);\n    margin: 0;\n}\n\n.auth-subtitle {\n    font-size: 0.75rem;\n    color: var(--lp-h-subtitulos);\n    margin: 0;\n}\n\n/* ── Form ───────────────────────────────────── */\n.auth-form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.auth-field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.auth-label {\n    font-size: 0.75rem;\n    font-weight: var(--lp-fw-bold);\n    color: var(--lp-h-titulos);\n}\n\n.auth-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.auth-input-icon {\n    position: absolute;\n    left: 16px;\n    color: var(--lp-h-subtitulos);\n    font-size: 1.2rem;\n}\n\n.auth-input {\n    width: 100%;\n    height: 52px;\n    background: var(--lp-surface-card);\n    border: 1px solid var(--lp-border-light);\n    border-radius: 8px;\n    padding: 0 16px 0 48px;\n    font-size: 0.75rem;\n    color: var(--lp-h-titulos);\n    font-family: inherit;\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.auth-input:focus {\n    outline: none;\n    box-shadow: 0 0 0 1px var(--lp-blue-dark);\n}\n\n.auth-input.has-icon-right {\n    padding-right: 48px;\n}\n\n.auth-forgot-link {\n    align-self: flex-end;\n    margin-top: -4px;\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 0.75rem;\n    font-weight: var(--lp-fw-bold);\n    color: var(--lp-text-jph-brand);\n    cursor: pointer;\n    text-decoration: none;\n    transition: color 0.2s ease;\n}\n\n.auth-forgot-link:hover {\n    text-decoration: underline;\n}\n\n.auth-input-btn {\n    position: absolute;\n    right: 12px;\n    background: none;\n    border: none;\n    color: var(--lp-border-light);\n    cursor: pointer;\n    font-size: 1.2rem;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n}\n\n.auth-btn-submit {\n    height: 52px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    background-color: var(--lp-blue-dark);\n    color: var(--lp-text-on-primary);\n    border: 1px solid color-mix(in srgb, var(--lp-blue-dark) 72%, var(--lp-border-light));\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: var(--lp-fw-bold);\n    font-family: inherit;\n    cursor: pointer;\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n    margin-top: 8px;\n}\n\n.auth-btn-submit:hover:not(:disabled) {\n    background-color: color-mix(in srgb, var(--lp-blue-dark) 88%, var(--lp-surface-card));\n    border-color: color-mix(in srgb, var(--lp-blue-dark) 60%, var(--lp-border-light));\n    color: var(--lp-text-on-primary);\n}\n\n.auth-btn-submit:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.auth-submit-row {\n    display: flex;\n    align-items: stretch;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.auth-submit-row .auth-btn-submit {\n    flex: 1;\n    margin-top: 0;\n}\n\n.auth-social-btn {\n    flex: 0 0 52px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--lp-background-divs);\n    border: 1px solid var(--lp-border-light);\n    border-radius: 8px;\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n    cursor: pointer;\n    color: var(--lp-text-primary);\n    font-size: 1.35rem;\n}\n\n.auth-social-btn:hover:not(:disabled) {\n    background-color: var(--lp-btn-hover);\n    border-color: color-mix(in srgb, var(--lp-text-jph-brand) 35%, var(--lp-border-light));\n    color: var(--lp-text-primary);\n}\n\n.auth-social-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.auth-spinner--social {\n    width: 20px;\n    height: 20px;\n}\n\n.auth-btn-submit--biometric {\n    gap: 10px;\n}\n\n.auth-method-switch {\n    align-self: center;\n    margin-top: 4px;\n    background: none;\n    border: none;\n    padding: 8px 4px;\n    font-size: 0.8125rem;\n    font-weight: var(--lp-fw-bold);\n    color: var(--lp-text-jph-brand);\n    cursor: pointer;\n    text-decoration: none;\n    transition: color 0.2s ease;\n}\n\n.auth-method-switch:hover:not(:disabled) {\n    text-decoration: underline;\n}\n\n.auth-method-switch:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* ── Footer / Support ───────────────────────── */\n.auth-footer-support {\n    text-align: center;\n    font-size: 0.75rem;\n    color: var(--lp-h-titulos);\n}\n\n.auth-footer-support a {\n    color: var(--lp-h-titulos);\n    font-weight: var(--lp-fw-bold);\n    text-decoration: none;\n}\n\n.auth-footer-support a:hover {\n    text-decoration: underline;\n}\n\n/* ── Alerts ─────────────────────────────────── */\n.auth-error,\n.auth-info {\n    padding: 12px;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    line-height: 1.45;\n}\n\n.auth-error {\n    background-color: var(--lp-error-bg);\n    border: 1px solid var(--lp-error-border);\n    color: var(--lp-error-color);\n}\n\n.auth-info {\n    background-color: var(--lp-info-bg);\n    border: 1px solid var(--lp-info-border);\n    color: var(--lp-info-color);\n}\n\n/* ── Spinner ────────────────────────────────── */\n.auth-spinner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid var(--lp-spinner-ring);\n    border-top-color: var(--lp-blue-dark);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.auth-btn-submit .auth-spinner {\n    border-color: color-mix(in srgb, var(--lp-text-on-primary) 35%, transparent);\n    border-top-color: var(--lp-text-on-primary);\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* ── Modal (Forgot Password) ────────────────── */\n.auth-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: var(--lp-backdrop);\n    z-index: 3200;\n}\n\n.auth-modal-panel {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: var(--lp-surface-card);\n    border-radius: 16px;\n    padding: 24px 20px 20px;\n    width: min(440px, calc(100vw - 32px));\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    z-index: 3201;\n    box-shadow: var(--lp-modal-shadow);\n}\n\n.auth-modal-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.auth-modal-title-block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.auth-modal-title {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: var(--lp-fw-bold);\n    color: var(--lp-h-titulos);\n}\n\n.auth-modal-subtitle {\n    margin: 0;\n    font-size: 0.75rem;\n    color: var(--lp-h-subtitulos);\n}\n\n.auth-modal-close {\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    border: none;\n    background: var(--lp-background-divs);\n    border-radius: 8px;\n    color: var(--lp-h-subtitulos);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.1rem;\n}\n\n.auth-modal-close:hover:not(:disabled) {\n    background: var(--lp-modal-close-hover);\n    color: var(--lp-h-titulos);\n}\n\n.auth-modal-close:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.auth-modal-panel .auth-form {\n    gap: 16px;\n}\n\n.auth-modal-footer {\n    display: flex;\n    gap: 10px;\n    padding-top: 4px;\n}\n\n.auth-modal-footer .auth-btn-secondary,\n.auth-modal-footer .auth-btn-primary {\n    flex: 1 1 0;\n    min-height: 44px;\n    padding: 0 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    font-weight: var(--lp-fw-bold);\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s;\n    white-space: nowrap;\n}\n\n.auth-modal-footer .auth-btn-secondary {\n    background: var(--lp-background-divs);\n    border: 1px solid var(--lp-border-light);\n    color: var(--lp-h-titulos);\n}\n\n.auth-modal-footer .auth-btn-secondary:hover:not(:disabled) {\n    background: var(--lp-modal-close-hover);\n}\n\n.auth-modal-footer .auth-btn-primary {\n    background-color: var(--lp-blue-dark);\n    color: var(--lp-text-on-primary);\n    border: 1px solid color-mix(in srgb, var(--lp-blue-dark) 72%, var(--lp-border-light));\n}\n\n.auth-modal-footer .auth-btn-primary:hover:not(:disabled) {\n    background-color: color-mix(in srgb, var(--lp-blue-dark) 88%, var(--lp-surface-card));\n    border-color: color-mix(in srgb, var(--lp-blue-dark) 60%, var(--lp-border-light));\n    color: var(--lp-text-on-primary);\n}\n\n.auth-modal-footer .auth-btn-secondary:disabled,\n.auth-modal-footer .auth-btn-primary:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* ── Responsive ─────────────────────────────── */\n@media (max-width: 768px) {\n    .header-top {\n        padding: 1rem;\n    }\n\n    .auth-card {\n        padding: 0;\n        gap: 24px;\n    }\n\n    .auth-title {\n        font-size: 1.75rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
